import React, { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function ResetPassword() {
	const { resetPassword } = useAuth()
	const [searchParams]    = useSearchParams()
	const resetToken        = searchParams.get('token') || ''

	const [password, setPassword] = useState('')
	const [confirm, setConfirm]   = useState('')
	const [error, setError]       = useState('')
	const [success, setSuccess]   = useState('')
	const [loading, setLoading]   = useState(false)

	async function handleSubmit(e) {
		e.preventDefault()
		setError('')
		if (password !== confirm) { setError('Passwords do not match'); return }
		setLoading(true)
		try {
			const msg = await resetPassword(resetToken, password)
			setSuccess(msg)
		} catch (err) {
			setError(err.message)
		} finally {
			setLoading(false)
		}
	}

	if (!resetToken) return (
		<div className='authPage'>
			<div className='authCard'>
				<div className='authError'>Invalid or missing reset token.</div>
				<div className='authLinks'><Link to='/forgot-password'>Request a new link</Link></div>
			</div>
		</div>
	)

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>New password</h2>

				{error   && <div className='authError'>{error}</div>}
				{success && <div className='authSuccess'>{success} <Link to='/login'>Log in</Link></div>}

				{!success && (
					<form onSubmit={handleSubmit}>
						<div className='authField'>
							<label>New password <small>(8 characters minimum)</small></label>
							<input
								type='password'
								value={password}
								onChange={e => setPassword(e.target.value)}
								required
								minLength={8}
								autoFocus
							/>
						</div>
						<div className='authField'>
							<label>Confirm new password</label>
							<input
								type='password'
								value={confirm}
								onChange={e => setConfirm(e.target.value)}
								required
							/>
						</div>
						<button className='authBtn' disabled={loading}>
							{loading ? 'Saving…' : 'Set new password'}
						</button>
					</form>
				)}
			</div>
		</div>
	)
}

export default ResetPassword
